import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import { DateCalendar } from '@mui/x-date-pickers'
import { PickersDay } from '@mui/x-date-pickers/PickersDay'
import * as React from 'react'

const CustomPickersDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'isHovered',
})(({ theme, isSelected, isHovered, day }) => ({
    borderRadius: 0,
    ...(isSelected && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary.main,
        },
    }),
    ...(isHovered && {
        backgroundColor: theme.palette.primary[theme.palette.mode],
        '&:hover, &:focus': {
            backgroundColor: theme.palette.primary[theme.palette.mode],
        },
    }),
    ...(day.day() === 1 && {
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
    }),
    ...(day.day() === 0 && {
        borderTopRightRadius: '50%',
        borderBottomRightRadius: '50%',
    }),
}))

const isInSameWeek = (dayA, dayB) => {
    if (dayB == null) { return false }
    return dayA.isSame(dayB, 'week')
}

const Day = ({ day, selectedDay, hoveredDay, ...other }) => <CustomPickersDay
    {...other}
    day={day}
    sx={{ px: 2.5 }}
    disableMargin
    selected={false}
    isSelected={isInSameWeek(day, selectedDay)}
    isHovered={isInSameWeek(day, hoveredDay)}
/>

const getFirstAndLastDatesOfWeek = value => {
    return { firstDay: value.weekday(0), lastDay: value.weekday(6) }
}

const WeekPicker = ({ onChangeDates, textFieldProps, value }) => {

    const [open, setOpen] = React.useState(false)
    const [hoveredDay, setHoveredDay] = React.useState(null)

    const handleChange = newValue => {
        const { firstDay, lastDay } = getFirstAndLastDatesOfWeek(newValue)
        onChangeDates({
            firstDay: firstDay,
            lastDay: lastDay,
            value: newValue.weekday(1),
        })
        handleClose()
    }

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    const getTextFieldValue = () => {
        const { firstDay, lastDay } = getFirstAndLastDatesOfWeek(value)
        return `${firstDay.toDate().toLocaleDateString().slice(0, 5)} - ${lastDay.toDate().toLocaleDateString().slice(0, 5)}`
    }

    return <>

        <TextField
            id="datepicker"
            name="datepicker"
            fullWidth={false}
            value={getTextFieldValue()}
            onClick={handleOpen}
            inputProps={{ readOnly: true, sx: { cursor: "pointer" } }}
            sx={{ cursor: "pointer" }}
            {...textFieldProps}
        />
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Выберите неделю</DialogTitle>
            <DialogContent sx={{ m: 0, p: 1 }}>
                <DateCalendar
                    value={value}
                    onChange={handleChange}
                    showDaysOutsideCurrentMonth
                    displayWeekNumber
                    slots={{ day: Day }}
                    slotProps={{
                        textField: { fullWidth: false },
                        day: (ownerState) => ({
                            selectedDay: value,
                            hoveredDay,
                            onPointerEnter: () => setHoveredDay(ownerState.day),
                            onPointerLeave: () => setHoveredDay(null),
                        }),
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={handleClose}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    </>
}

export default WeekPicker 